import { useAuth } from "../../common/auth.context";
import curinosLogo from "./curinosLogo.jpg";

export default function Login() {
  const { login } = useAuth();

  const handleLogin = async () => {
    try {
      await login();
    } catch (err) {
      console.error("SSO Login error:", err);
    }
  };

  return (
    <div 
      style={{
        backgroundColor: "#999",
        width: "100vw",
        height: "100vh",
        display: "flex",
        alignItems: "flex-start",
        paddingTop: "5%",
        justifyContent: "center",
      }}
    >
      <div 
        style={{
          width: "360px",
          backgroundColor: "#fff",
          borderRadius: "4px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
        }}
      >
        {/* ---- TOP BANNER ---- */}
        <div className="banner-customizable" style={{ textAlign: "center", backgroundColor: "#444957" }}>
          <img
            src={curinosLogo}
            alt="Logo"
            className="logo-customizable"
            style={{ margin: "15px auto" }}
          />
        </div>

        {/* ---- CONTENT ---- */}
        <div style={{ padding: "30px" }}>
          <button
            style={{
                width: "100%",
                height: "45px",
                backgroundColor: "#444957",
                color: "#ffffff",
                fontsize: "16px",
                fontWeight: "600",
                borderRadius: "8px",
                border: "none",
                cursor: "pointer",
            }}
            onClick={handleLogin}
          >
            Sign In with SSO
          </button>
        </div>
      </div>
    </div>
  );
}
